import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthProvider";
import API_BASE_URL from "../../config/apiConfig";
import ParentSidebar from "../../components/ParentSidebar";
import faceHappy from "../../assets/images/face-happy.svg";

const ParentDashboard: React.FC = () => {
const { userId, token } = useAuth(); // userId din AuthProvider

const [formData, setFormData] = useState({
  firstName: "",
  lastName: "",
});
const [error, setError] = useState<string | null>(null);

const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
  return localStorage.getItem("sidebarCollapsedParent") === "true";
});

useEffect(() => {
  const fetchParent = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/patient/${userId}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
      if (!response.ok) throw new Error("Userul nu a fost găsit.");
      const data = await response.json();
    //   console.log(data);
      setFormData({
        firstName: data.parent_firstname,
        lastName: data.parent_lastname,
    });
    } catch (err: any) {
      setError(err.message);
      console.log(error);
    }
  };

  fetchParent();
}, [userId]);
  

  return (
    <div className={`dashboard-container ${isCollapsed ? "collapsed" : ""}`}>
      <ParentSidebar onCollapseChange={(collapsed) => setIsCollapsed(collapsed)} />
    <div className="dashboard-content">
      <h1 className="user-welcome"><img src={faceHappy} alt="user" /> <span className="color-dark">Bine ai venit,</span> {formData.firstName} {formData.lastName}</h1>
      <div className="account-info">
      <h5>Acesta este contul tău de părinte, unde poți urmări programările săptămânale ale copilului tău la terapie. 
          În acest cont vei găsi toate sesiunile planificate pentru săptămâna selectată, inclusiv informații despre tipul terapiei și ora programării.</h5>

          <h5>Poți accesa programările fie prin acest <strong><a href="/parent/appointments">link</a></strong>, fie din meniul din stânga, apăsând pe butonul <strong>Programări</strong>.</h5>

          <h5>Pentru a schimba săptămâna afișată, selectează din calendar <strong>orice zi</strong> din săptămâna dorită — programările se vor actualiza automat.</h5>

          <h5>Dacă ai întrebări sau ai nevoie de ajutor, echipa noastră este mereu aici pentru tine.</h5>

      </div>
    </div>
    </div>
  );
};

export default ParentDashboard;
